import { FC, ReactElement, useMemo, useCallback, ReactNode } from 'react'
import { CryptoRewardsPanePreset } from 'components/features/rewards/rewardsPane/components/CryptoRewardsPanePreset/CryptoRewardsPanePreset'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import {
  getCryptoRewardsPaneProgressLabelStateSelector,
  getCryptoRewardsPaneProgressPercentsStateSelector,
  getCryptoRewardsPaneSellModeErrorsOrNullSelector,
} from 'components/features/rewards/rewardsPane/store/selectors/paneState'
import { GeneralError } from 'interfaces/errors'
import { useCryptoRewardsPaneModifyState } from 'components/features/rewards/rewardsPane/hooks/useCryptoRewardsPaneModifyFieldsState'
import { FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'
import { CryptoRewardsLoadingStateLabel } from 'components/features/rewards/rewardsPane/components/CryptoRewardsLoadingStateLabel/CryptoRewardsLoadingStateLabel'

type CryptoRewardsSellSendingOrderStepProps = {
  onClose: () => void
}

export const CryptoRewardsSellSendingOrderStep: FC<CryptoRewardsSellSendingOrderStepProps> = ({
  onClose,
}): ReactElement => {
  const paneErrors = useStoreSelector(getCryptoRewardsPaneSellModeErrorsOrNullSelector)
  const paneProgressPercent = useStoreSelector(getCryptoRewardsPaneProgressPercentsStateSelector)
  const paneProgressLabelOrNull = useStoreSelector(getCryptoRewardsPaneProgressLabelStateSelector)

  const cleanPaneStateErrors = useCryptoRewardsPaneModifyState(
    FLOATING_PANE_CRYPTO_REWARDS_SELL_MODE,
    { fields: { errors: undefined }}
  )

  const handleClearPaneStateErrors = useCallback(() => {
    cleanPaneStateErrors()
    onClose()
  }, [cleanPaneStateErrors, onClose])
  const paneErrorToRenderOrNull = useMemo<[GeneralError] | null>(() => (
    paneErrors?.length ? [paneErrors[0]] : null
  ), [paneErrors])
  const paneProgressLabelNodeOrNull = useMemo<ReactNode>(() => (
    paneProgressLabelOrNull && (
      <CryptoRewardsLoadingStateLabel>
        { paneProgressLabelOrNull }
      </CryptoRewardsLoadingStateLabel>
    )
  ), [paneProgressLabelOrNull])

  return (
    <CryptoRewardsPanePreset
      withoutFooter={ !paneErrorToRenderOrNull }
      isLoading={ !paneErrorToRenderOrNull }
      title='Sell Your Crypto Investments'
      subTitle=''
      errors={ paneErrorToRenderOrNull }
      onCancel={ onClose }
      progressBarPercent={ paneProgressPercent }
      onErrorsOverlayClosed={ handleClearPaneStateErrors }
      loadingStateLabel={ paneProgressLabelNodeOrNull }
    />
  )
}
